/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteReferralRecipientConfig200ResponseData
 */
export interface DeleteReferralRecipientConfig200ResponseData {
    /**
     * 
     * @type {number}
     * @memberof DeleteReferralRecipientConfig200ResponseData
     */
    id: number;
}

/**
 * Check if a given object implements the DeleteReferralRecipientConfig200ResponseData interface.
 */
export function instanceOfDeleteReferralRecipientConfig200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function DeleteReferralRecipientConfig200ResponseDataFromJSON(json: any): DeleteReferralRecipientConfig200ResponseData {
    return DeleteReferralRecipientConfig200ResponseDataFromJSONTyped(json, false);
}

export function DeleteReferralRecipientConfig200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteReferralRecipientConfig200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function DeleteReferralRecipientConfig200ResponseDataToJSON(value?: DeleteReferralRecipientConfig200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

